import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Slide from "reportengine/Slide";
import DomElement from "reportengine/DomElement";
import Portion from "reportengine/Portion";
import SlideTable from "reportengine/SlideTable";
import SlideTableRow from "reportengine/SlideTableRow";
import ProgressBar from "design/components/progress/ProgressBar";
import PercentageBar from "design/components/progress/PercentageBar";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { t } from "i18next";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import * as conf from "qpr-base/configuration";

const KPIPerformanceTable = (
  props: React.PropsWithChildren<{
    kpis: ICardElementWithChildren[];
    report: ICardElementWithChildren;
    title?: string;
    translatedScorecardName?: string;
  }>
) => {
  const { kpis } = props;
  const ctx = useAppContext();
  const tableSeries = conf.getKPIPerformanceTableSettings(kpis[0]);
  const getTableRow = (
    value: ICardElementWithChildren,
	  series: string,
    showRangeColors: boolean | undefined,
    colorAttribute: string | undefined
  ) => {
    if (!showRangeColors) {
      return (
        <TextElement slideElement="">
          {value[`${series}_prettyvalue` as keyof ICardElementWithChildren]}
        </TextElement>
      );
	  } else {
      return (
        <DomElement slideElement="" typename="image" selector=".item">
          <div
            className="item"
            style={{ width: "120px", height: "40px" }}
          >
            <PercentageBar
              color={`#${value[`${colorAttribute}` as keyof ICardElementWithChildren]}`}
              value={Number(value[`${series}` as keyof ICardElementWithChildren])}
            />
          </div>
        </DomElement>
	    );	
    }
  }
  //   const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  return (
    <>
      <Slide index={5}>
        <TextElement slideElement="title">
          {props.title || t("strategyReport.KPI Performance Summary")}
        </TextElement>
        <TextElement slideElement="period">
          {props.report.period?.name || ""}
        </TextElement>
        <TextElement slideElement="footer">
          {props.translatedScorecardName || t("strategyReport.Performance Report")}
        </TextElement>
        <Text slideElement="total_cnt">
          <Portion paragraphIndex={0} portionIndex={0}>
            {kpis.length}&nbsp;
          </Portion>
          <Portion paragraphIndex={0} portionIndex={1}>
            {t("strategyReport.TOTAL")}
          </Portion>
        </Text>
        <TextElement slideElement={"kpi_table_headerrow_name"} >
          {t("strategyReport.NAME")}
        </TextElement>
        {tableSeries.series?.map((ser, index) => {
          return (
            <TextElement slideElement={"kpi_table_headerrow" + index} >
              {t("strategyReport.KPItableCol" + index)}
            </TextElement>
           );
        })}

        <SlideTable slideElement="kpi_performance_table">
          {kpis.map((item) => {
            return (
              <SlideTableRow>
                <TextElement slideElement="">{getTranslatedAttribute(item, "Name", ctx.language)}</TextElement>
                {tableSeries.series?.map((ser, index) => {
                  return (
                    getTableRow(item, ser.symbol, ser.cellType === "percentageBar", ser.colorAttribute)
                  );
                })}
              </SlideTableRow>
            );
          })}
        </SlideTable>
      </Slide>
    </>
  );
};

export default KPIPerformanceTable;
